import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon, IconButton  } from '@material-ui/core';
import StarRatingComponent from 'react-star-rating-component';
import Utils from 'utils/Utils';
import BonusWidget from 'modules/Invite/containers/BonusWidget';
import ParticipantsWidget from 'modules/Invite/containers/ParticipantsWidget';
import InviteFriendsWidget from 'modules/Invite/containers/InviteFriendsWidget';
import PostsWidget from 'modules/Invite/containers/PostsWidget';
import TicketsWidget from 'modules/Invite/containers/TicketsWidget';
import './AdventureHeader.scss';

function AdventureHeader({ Adventure, RequestStore, ApplicationStore, isLogged, authUser }) {


    function handleFavorite() {

        if (!isLogged) {
            ApplicationStore.openModalLogin();
        }
    }

  return (
    <div className="adventure-header">
        <div className="content-info">
            <h2 className="adventure-name">
                {Adventure.title}
            </h2>
            <div className="adventure-actions">
                {Adventure.stars > 0 && 
                    <div className="avaliation">
                        <div>
                            <StarRatingComponent 
                                name="rate2" 
                                starCount={5}
                                value={Math.ceil(Number.parseFloat(Adventure.stars))}
                                edditable={false}
                                renderStarIcon={(index, value) => {
                                    return <span className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />;
                                }}
                                renderStarIconHalf={() => <span className="fa fa-star-half-full" />}
                            />
                            <span>({Number.parseFloat(Adventure.stars).toFixed(1)})</span>
                        </div>
                        <span className="adventure-sub-name-small">{Adventure.category_name}</span>
                    </div>
                }
                <span className="adventure-sub-name">{Adventure.category_name}</span>
                <div className="adventure-actions-buttons">
                    <Button onClick={handleFavorite} className="button-action" color="secondary" >
                        <Icon>favorite_border</Icon> SALVAR
                    </Button>
                    <Button onClick={() => Utils.shareLink(RequestStore.request == null ? Adventure.url : RequestStore.request.short_url)} className="button-action" color="secondary" >
                        <Icon>share</Icon> COMPARTILHAR
                    </Button>

                    <IconButton  onClick={handleFavorite} className="button-action-small" color="secondary" >
                        <Icon>favorite_border</Icon>
                    </IconButton >
                    <IconButton  onClick={() => Utils.shareLink(RequestStore.request == null ? Adventure.url : RequestStore.request.short_url)} className="button-action-small" color="secondary" >
                        <Icon>share</Icon>
                    </IconButton >
                </div>
            </div>
            <div className="company-content">
                <div className="company-info">
                    <div className="company-logo">
                        <img src={Adventure.company_logo} alt=""/>
                    </div>
                    <div className="company-text">
                        <strong>{Adventure.company}</strong>
                        <span>{Adventure.company_phone}</span>
                    </div>
                </div>
                <div>
                    <ul className="tags">
                        <li className="category alt">
                            {
                                ApplicationStore.minimalTemplate ? 
                                    <span>{Adventure.categoryName}</span>
                                :
                                    <Link to={`/${Adventure.region_url}/${Adventure.categoryUrl}`}>{Adventure.categoryName}</Link>
                            }
                        </li>
                        {Adventure.tags.map((tag, index) => {
                            if (index < 4) {
                                return (
                                    <li className="tag alt" key={index}>
                                        {tag.url_name && !ApplicationStore.minimalTemplate ?
                                        <Link to={`/tags/${tag.url_name}`}>
                                            {tag.name}
                                        </Link> 
                                        : tag.name}
                                    </li>
                                )
                            }
                        })}
                    </ul>
                </div>
            </div>
        </div>

        <div className="adventure-description">
            <p>{Adventure.description}</p>
        </div>
        
        <div className="adventure-duration-participants">
            {Adventure.duration && Adventure.duration != '00:00' && 
                <div>
                    <Icon color="secondary">query_builder</Icon>
                    {`${Adventure.durationFormatted} de duração`}
                </div>
            }
            {Adventure.min &&
                <div>
                    <Icon color="secondary">person_outline</Icon>
                    {`Min. ${Adventure.min || 1} ${(parseInt(Adventure.min || 1) === 1) ? "participante" : "participantes"}`}
                </div>
            }
            {Adventure.max &&
                <div>
                    <Icon color="secondary">people_outline</Icon>
                    {`Máx. ${Adventure.max} ${(parseInt(Adventure.max) === 1) ? "participante" : "participantes"}`}
                </div>
            }
        </div>

        <div className="Invite-Content">
            <BonusWidget Adventure={Adventure} Request={RequestStore.request} />
            {RequestStore.request && RequestStore.request.reserves.length > 0 && 
                <ParticipantsWidget 
                    Request={RequestStore.request} 
                    isLogged={isLogged} 
                    ApplicationStore={ApplicationStore}
                />
            }
            <InviteFriendsWidget Request={RequestStore.request} />
            {isLogged && RequestStore.request && 
                RequestStore.request.reserves.find(
                    r => authUser && (r.email === authUser.email || authUser.pk_user === r.fk_user)
                ) &&
                <>
                    <PostsWidget
                        Adventure={Adventure} 
                        messages={RequestStore.request.messages}
                    />
                    <TicketsWidget
                        reserves={RequestStore.request.reserves} 
                        authUser={authUser} 
                    />
                </>
            }
        </div>
    </div>
  );
}

export default AdventureHeader;